export default "__VITE_ASSET__DsgP_f7$__"